(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSitePartRelationshipDeleteController',PublicSitePartRelationshipDeleteController);

    PublicSitePartRelationshipDeleteController.$inject = ['$uibModalInstance', 'entity', 'PublicSitePartRelationship'];

    function PublicSitePartRelationshipDeleteController($uibModalInstance, entity, PublicSitePartRelationship) {
        var vm = this;

        vm.publicSitePartRelationship = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PublicSitePartRelationship.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
